module.exports = __webpack_public_path__ + "img/load-1-3.ca117fb4.png";